<template>
  <c-dialog ref="dialogRef" :return-data="printMode">
    <c-field>
      <div class="tw-space-y-3">
        <c-label label="Kies wat je wilt printen" />

        <c-radio-group
          v-model="printMode"
          :options="PORTFOLIO_PRINT_MODE_OPTIONS"
          class="tw-gap-2"
        />
      </div>
    </c-field>
  </c-dialog>
</template>

<script setup lang="ts">
import {
  PORTFOLIO_PRINT_MODE_OPTIONS,
  PORTFOLIO_PRINT_MODES,
} from "portfolio/constants";
import CField from "shared/components/wrappers/field/CField.vue";
import { ref } from "vue";

// Refs
const dialogRef = ref(null);
const printMode = ref(PORTFOLIO_PRINT_MODES.All);
</script>
